module.exports = __webpack_public_path__ + "static/media/home.68e3fa7e.png";